import React, { useCallback, useState, useEffect } from "react"
import { useDropzone } from "react-dropzone"

const DropzoneComponent = ({
  onDropAccepted,
  isOpen,
  maxFiles = 1,
  id = 0,
}) => {
  //
  const [isDragActive, setIsDragActive] = useState(false)
  const [identificator, setId] = useState(id)
  //
  // Sincroniza el estado interno `identificator` con la prop `id`
  useEffect(() => {
    //console.log("id cambió:", id)
    setId(id)
  }, [id])

  const onDrop = useCallback(
    acceptedFiles => {
      const formData = new FormData();
      const base64Files = [];

      acceptedFiles.forEach((file, index) => {
        if (index >= maxFiles) {
          console.warn(`File "${file.name}" was ignored due to max file limit.`);
          return;
        }
        
        formData.append("file", file); // Append file to formData

        // FileReader to convert file to base64 string
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          base64Files.push(reader.result); // Store the base64 string in an array
          
          // If all files have been processed, call the callback
          if (base64Files.length === acceptedFiles.slice(0, maxFiles).length) {
            onDropAccepted({
              formData,
              base64Files,
              identificator
            });
          }
        };
        reader.onerror = (error) => {
          console.error('Error reading file:', error);
        };
      });

      setIsDragActive(false);
    },
    [identificator, maxFiles, onDropAccepted]
  );

  const onDragEnter = () => setIsDragActive(true)
  const onDragLeave = () => setIsDragActive(false)

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    onDragEnter,
    onDragLeave,
  })

  const baseStyle = {
    borderWidth: 2,
    borderRadius: 5,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    padding: "20px",
    width: "100%",
    textAlign: "center",
    transition: "border .3s ease-in-out",
  }

  const activeStyle = {
    borderColor: "#2196f3",
    backgroundColor: "#e3f2fd",
  }

  const rejectStyle = {
    borderColor: "#ff1744",
    backgroundColor: "#ffebee",
  }

  return (
    <React.Fragment>
      {isOpen ? (
        <div className="dropzone">
          <div
            className="dz-message needsclick mt-2"
            {...getRootProps({
              style: isDragActive
                ? { ...baseStyle, ...activeStyle }
                : baseStyle,
            })}
          >
            <input {...getInputProps()} />
            <div className="mb-3">
              <i className="display-4 text-muted bx bxs-cloud-upload" />
            </div>
            <h4>
              {isDragActive
                ? "Suelta los archivos aquí..."
                : "Arrastra archivos aquí o haz clic para subir"}
            </h4>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  )
}

export default DropzoneComponent
